import React, { useEffect, useState } from "react";
import FadeLoader from "react-spinners/FadeLoader";
import { useUser } from "../utils/UserContext.jsx";
import "./ownerDashboard.css";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import BankDetailsMain from "../bankDetails/bankDetailsMain.jsx";
import {fetchAllPSLData,fetchOwnerEarnings,fetchParkingOverview,fetchBankDetailsByEntity} from "../../Services/userService.js";


/* ===== IMAGE IMPORTS ===== */
import activeIcon from "../../Images/active-icon.png";
import pendingIcon from "../../Images/pending-icon.png";
import draftIcon from "../../Images/draft-icon.png";
import deactivateIcon from "../../Images/deactivate-icon.png";
import dollarIcon from "../../Images/CurrencyDollar.png";

import sessionIcon from "../../Images/session-icon.png";
import spotIcon from "../../Images/spot-icon.png";
import utilizationIcon from "../../Images/utilization-icon.png";
import peakIcon from "../../Images/peak-icon.png";
import GearSix from "../../Images/GearSix.png";
import imagebank from "../../Images/imagebank.png";
import ArrowSquareOut from "../../Images/ArrowSquareOut.png";
import BulbImage from "../../Images/BulbImage.png";

const OwnerDashboard = ({ entityId: propEntityId }) => {
//   const hostPath = process.env.REACT_APP_API_BASE_URL;
//   const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;

  const { userDetails, employeeData, empDetails } = useUser();
  const navigate = useNavigate();

  const entityId =
    propEntityId ||
    userDetails?.entityRegistrationID ||
    employeeData?.entityRegistrationID;

  const [summary, setSummary] = useState(null);
  const [earnings, setEarnings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [parkingOverview, setParkingOverview] = useState(null);
  const [bankDetails, setBankDetails] = useState([]);
  const [lotList, setLotList] = useState([]);
  const [selectedLotId, setSelectedLotId] = useState("All");
  const [currentTime, setCurrentTime] = useState(new Date());
  const [openBankPage, setOpenBankPage] = useState(false);
  

  const getFullName = (user) =>
    [user?.firstName, user?.lastName].filter(Boolean).join(" ");

  const activeBank =
  bankDetails?.find((b) => b.isActive) || bankDetails?.[0];

  const fullName =
    getFullName(empDetails) ||
    getFullName(userDetails) ||
    getFullName(employeeData) ||
    "User";

    const pendingAmount = Number(earnings?.pendingCashoutAmount ?? 0);
const isCashoutDisabled = pendingAmount < 25;

/* ================= LIVE SYNC STATUS ================= */

const getSyncStatus = (lastSyncedTime, nowTime) => {
  if (!lastSyncedTime) {
    return { text: "Not synced", className: "status-red" };
  }

  const synced = new Date(lastSyncedTime);

  const diffMinutes = Math.floor(
    (nowTime - synced) / 60000
  );

  if (diffMinutes <= 5) {
    return { text: "Live", className: "status-green" };
  }

  if (diffMinutes <= 60) {
    return {
      text: `Synced ${diffMinutes} min ago`,
      className: "status-orange",
    };
  }

  return {
    text: `Last synced ${Math.floor(diffMinutes / 60)} hr ago`,
    className: "status-red",
  };
};

const syncStatus = getSyncStatus(
  parkingOverview?.lastSyncedTime,
  currentTime
);

  /* ================= FETCH FUNCTIONS ================= */

    const loadAllPSLData = async (id) => {
      try {
        const data = await fetchAllPSLData(id);
        setSummary(data || {});
        setLotList(data?.parkingLots || []);
      } catch (error) {
        console.error(error);
      }
    };

    const loadOwnerEarnings = async (id) => {
      try {
        const data = await fetchOwnerEarnings(id);
        setEarnings(data || {});
      } catch (error) {
        console.error(error);
      }
    };

    const loadParkingOverview = async (entityId, lotId = "All") => {
      try {
        const data = await fetchParkingOverview(entityId, lotId);
        setParkingOverview(data || {});
      } catch (error) {
        console.error(error);
      }
    };

    const loadBankDetails = async (id) => {
      try {
        const data = await fetchBankDetailsByEntity(id);
        setBankDetails(data || []);
      } catch (error) {
        console.error(error);
      }
    };

  /* ================= LOAD DASHBOARD ================= */

  useEffect(() => {
    if (!entityId) return;

    const loadDashboard = async () => {
      try {
        setLoading(true);
        setError(null);

        await Promise.all([
          loadAllPSLData(entityId),
          loadOwnerEarnings(entityId),
          loadParkingOverview(entityId),
          loadBankDetails(entityId),
        ]);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadDashboard();
  }, [entityId]);

  useEffect(() => {
  if (!entityId) return;

  loadParkingOverview(entityId, selectedLotId);
}, [selectedLotId, entityId]);

/* ===== UPDATE TIME EVERY MINUTE ===== */

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentTime(new Date());
  }, 60000); // 1 minute

  return () => clearInterval(interval);
}, []);


  if (error) {
    return <div className="error-message">❌ {error}</div>;
  }

  // ✅ OPEN BANK PAGE FULL SCREEN
if (openBankPage) {
  return (
    <BankDetailsMain
      entity={entityId}
      openEditDirectly={true}
      handlebankdetails={() => {
        setOpenBankPage(false);
        loadBankDetails(entityId);
      }}
    />
  );
}

  return (
    <div className="owner-dashboard-wrapper">
      <div className="dashboard-container">
        {loading && (
          <div className="loader-overlay">
            <FadeLoader />
          </div>
        )}

        {/* ================= HEADER ================= */}

        <div className="dashboard-header">
          <div>
            <h2>
              Welcome back, <span>{fullName}</span>
            </h2>
            <p>
              Here’s a quick snapshot of how your lots are performing today.
            </p>
          </div>

          {/* ✅ BUTTON ONLY FOR Owner */}
          <button
            type="button"
            className="primary-btn"
            onClick={() =>
              navigate("/dashboard", {
                state: { isDashboard: false }
              })
            }
          >
            + Add New Property
          </button>
        </div>
        <div className="header-divider"></div>
        <h4 className="section-title">Your Parking Overview</h4>


        {/* ================= TOP SECTION ================= */}

        <div className="dashboard-top">

          {/* ===== LEFT GRID ===== */}

          <div className="overview-grid">

            <div className="overview-card">
              <img src={activeIcon} alt="active" className="icon-wrapper green-bg" />
              <h5>Active Lots</h5><br />
              <h2>{summary?.activePSLCount ?? 0}</h2>
              <p>Generating steady revenue</p>
            </div>

            <div className="overview-card">
              <img src={pendingIcon} alt="pending" className="icon-wrapper yellow-bg" />
              <h5>Pending Approvals</h5><br />
              <h2>{summary?.pendingPSLCount ?? 0}</h2>
              <p>Awaiting review</p>
            </div>

            <div className="overview-card">
              <img src={draftIcon} alt="draft" className="icon-wrapper blue-bg" />
              <h5>Draft Lots</h5><br />
              <h2>{summary?.draftPSLCount ?? 0}</h2>
              <p>Finish setup to start earning</p>
            </div>

            <div className="overview-card">
              <img src={deactivateIcon} alt="deactivated" className="icon-wrapper red-bg" />
              <h5>Deactivated Lots</h5><br />
              <h2>{summary?.deactivatedPSLCount ?? 0}</h2>
              <p>Under maintenance</p>
            </div>

          </div>

          {/* ===== BLUE EARNINGS CARD ===== */}

          <div className="earnings-card">
         <div className="earnings-icon-wrapper">
            <img src={dollarIcon} alt="earnings" />
          </div>

            <h5>Total Earnings</h5>

            <h1>
              ${Number(earnings?.totalEarnings ?? 0).toFixed(2)}
            </h1>

            <div className="earnings-row">

              <div>
                <p>This Month</p>
                <strong>
                  ${Number(earnings?.thisMonthEarnings ?? 0).toFixed(2)}
                </strong>
              </div>

              <div>
                <p>Today so far</p>
                <strong>
                  ${Number(earnings?.todayEarnings ?? 0).toFixed(2)}
                </strong>
              </div>

              <div>
                <p>Pending Cashout</p>
                <strong>
                  ${Number(earnings?.pendingCashoutAmount ?? 0).toFixed(2)}
                </strong>
              </div>

            </div>

              {isCashoutDisabled ? (
                <button className="cashout-btn" disabled>
                  Request Cashout
                </button>
              ) : (
                <Link to="/earnings" className="cashout-link">
                  <button className="cashout-btn">
                    Request Cashout
                  </button>
                </Link>
              )}<br /><br />

            <p className="minimum-text">
               <span className="info-icon">i</span>
              Minimum Cashout balance: $25
            </p>

          </div>

        </div>

        {/* ================= STATIC SECTION ================= */}

            <div className="static-section">
                  <div className="card static-card">

                    <div className="activity-header">
                      <div>
                        <h4>Overall Parking Activity</h4>
                        <p>Real time across all active properties</p>
                      </div>

                    <div className="activity-actions">
                      <div className="custom-dropdown">
                        <select
                          className="filter-dropdown"
                          value={selectedLotId}
                          onChange={(e) => setSelectedLotId(e.target.value)}
                        >
                          <option value="All">All</option>

                          {lotList?.map((lot) => (
                            <option
                              key={lot.parking_Lot_ID}
                              value={lot.parking_Lot_ID}
                            >
                              {lot.nickName}
                            </option>
                          ))}
                        </select>
                      </div>

                      <button className={`live-btn ${syncStatus.className}`}>
                        <span className="live-dot"></span>
                        {syncStatus.text}
                      </button>
                    </div>
                    </div>

                    <div className="activity-grid">

                      <div className="activity-card">
                        <div className="activity-icon">
                          <img src={sessionIcon} alt="sessions" />
                        </div>
                        <p className="activity-label">Active Sessions</p><br />
                        <h3>{parkingOverview?.robotaxiActiveSessions ?? 0}</h3>
                        <span className="activity-subtext">Robotaxis parked now</span>
                      </div>

                      <div className="activity-card">
                        <div className="activity-icon purple-bg">
                          <img src={spotIcon} alt="spots" />
                        </div>
                        <p className="activity-label">Available Spots</p><br />
                        <h3>{parkingOverview?.robotaxiActiveSpots ?? 0}</h3>
                        <span className="activity-subtext">
                          Out of {parkingOverview?.totalRoboTaxiSpots ?? 0} total spaces
                        </span>
                      </div>

                      <div className="activity-card">
                        <div className="activity-icon purple-bg">
                          <img src={utilizationIcon} alt="utilization" />
                        </div>
                        <p className="activity-label">Utilization Rate</p><br />
                        <h3>
                          {Math.round(parkingOverview?.utilizationRate ?? 0)}%
                        </h3>
                        <span className="activity-subtext">Average across lots</span>
                      </div>

                      <div className="activity-card">
                        <div className="activity-icon purple-bg">
                          <img src={peakIcon} alt="peak" />
                        </div>
                        <p className="activity-label">Peak Hours</p><br />
                        <h3>9 AM - 1 PM</h3>
                        <span className="activity-subtext">Busiest times of day</span>
                      </div>

                    </div>
                  </div>
                </div>

        {/* ================= BOTTOM SECTION ================= */}

            <div className="bottom-section">

              
              {/* ===== PRO TIP ===== */}
            <div className="bottom-card tip-card">

              <img src={BulbImage} alt="tip-icon" className="tip-image" />

              <h4>Pro Tip</h4>

              <p>
                Your <strong>{parkingOverview?.highestLotName || "No properties"}</strong> has the highest
                utilization at {parkingOverview?.highestLotUtilization}%. Consider adding more spaces or increasing
                rates during peak hour.
              </p>

                <button
            className="view-btn"
            disabled={!parkingOverview || !parkingOverview?.highestLotName}
            onClick={() =>
              parkingOverview?.highestLotName &&
              navigate("/viewparkinginfo", {
                state: {
                  lotName: parkingOverview.highestLotName,
                },
              })
            }
          >
            View Property
          </button>

            </div>

            </div>
              
      </div>
    </div>
  );
};

export default OwnerDashboard;